import React from "react";
import BfIcon from "../../../icon/BfIcon";
import "./NoDataComponent.scss";

type Props = {
  errorMessage?: string;
  children?: React.ReactNode;
};

const NoDataComponent: React.FC<Props> = (props) => {
  const { children, errorMessage } = props;

  return (
    <div className={`no-data-component `}>
      {errorMessage ? (
        <div className={`error`}>
          <div className={`icon`}>
            <BfIcon type="bf" data="alert-triangle" size="2x" />
          </div>
          <div className={`message`}>{errorMessage}</div>
        </div>
      ) : (
        children
      )}
    </div>
  );
};

export default NoDataComponent;
